import { defineMessages } from 'react-intl';

export default defineMessages({
    baDriverAssignmentTitle: {
        id: 'quoteandbind.ba.directives.templates.ba-driver-assignment.Vehicle',
        defaultMessage: 'Vehicle',
    },
    baDriverAssignmentAdd: {
        id: 'quoteandbind.ba.directives.templates.ba-driver-assignment.Add Driver Assignment',
        defaultMessage: 'Add Driver Assignment',
    },
    baDriverAssignmentDriver: {
        id: 'quoteandbind.ba.directives.templates.ba-driver-assignment.Driver',
        defaultMessage: 'Driver',
    },
    baDriverAssignmentTitleLatest: {
        id: 'quoteandbind.ba.directives.templates.ba-driver-assignment.Driver Assignment',
        defaultMessage: 'Driver Assignment',
    },
    baDriverAssignmentYears: {
        id: 'quoteandbind.ba.directives.templates.ba-driver-assignment.Years of Experience',
        defaultMessage: 'Years of Experience',
    },
    baDriverAssignmentRateable: {
        id: 'quoteandbind.ba.directives.templates.ba-driver-assignment.Rateable Occasional Driver',
        defaultMessage: 'Rateable Occasional Driver',
    },
    baDriverAssignmentRemove: {
        id: 'quoteandbind.ba.directives.templates.ba-driver-assignment.Remove',
        defaultMessage: 'Remove',
    },
});
